import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import './styles.css';

registerSW({
  immediate: true,
  onRegisteredSW(_scriptUrl, registration) {
    if (!registration) return;
    const checkForUpdate = () => void registration.update();
    addEventListener('online', checkForUpdate);
    setInterval(checkForUpdate, 60 * 60 * 1000);
  }
});

async function bootstrap() {
  if (import.meta.env.DEV && new URLSearchParams(location.search).has('demo')) {
    const { seedDemoItems } = await import('./demo/seed');
    await seedDemoItems();
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

void bootstrap();
